import { isEmpty } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { useTypedParams } from 'react-router-typesafe-routes';
import { ApplicationListItem } from '@/components/contacts/application-list/application-list-item';
import GroupJoinApplicationListItem from '@/components/contacts/application-list/group-join-application-list-item';
import EmptyLayout from '@/components/layouts/empty-layout';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import useGroupJoinApplications from '@/hooks/groups/use-group-join-applications';
import ROUTES from '@/routes';

export default function GroupApplicationsRoute() {
  const { t } = useTranslation();

  const { id: groupId } = useTypedParams(ROUTES.MESSAGES.GROUPS.SETTINGS.ADMIN.APPLICATIONS);
  const { data, isLoading } = useGroupJoinApplications(groupId);

  return (
    <PageLayout
      title={t('conversation.setting.group.application.title')}
      headerConfig={{
        navigateBack: true,
      }}>
      <div className='mx-5 mt-4 pb-safe-offset-4 desktop:overflow-auto desktop:pb-8'>
        {!isEmpty(data?.applications) && (
          <>
            <h2 className='font-bold mb-4 text-body1'>{t('contact.applications.pending-applications')}</h2>

            <LoadingLayout promise={isLoading}>
              {() => (
                <ul className='flex w-full flex-col items-stretch mb-6 gap-6 desktop:overflow-y-auto'>
                  {data?.applications.map((application) => (
                    <li
                      key={application.id}
                      className='w-full'>
                      <GroupJoinApplicationListItem
                        groupId={groupId}
                        application={application}
                      />
                    </li>
                  ))}
                </ul>
              )}
            </LoadingLayout>
          </>
        )}

        <h2 className='font-bold mb-4 text-body1'>{t('contact.applications.past-applications')}</h2>

        <LoadingLayout promise={isLoading}>
          {() =>
            !isEmpty(data?.pastApplications) ? (
              <ul className='flex w-full flex-col items-stretch gap-6 desktop:overflow-y-auto'>
                {data?.pastApplications.map((application) => (
                  <li
                    key={application.id}
                    className='w-full'>
                    <ApplicationListItem application={application} />
                  </li>
                ))}
              </ul>
            ) : (
              <EmptyLayout
                className='flex'
                label='contact.applications.empty'
              />
            )
          }
        </LoadingLayout>
      </div>
    </PageLayout>
  );
}
